var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34-18H14c-2.2 0-4 1.8-4 4v32l14-6 14 6v-32c0-2.2-1.8-4-4-4z",
    fill: "currentColor"
  })));
}

export default SvgBookmark;